module.exports = __webpack_public_path__ + "static/img/phone.0516125.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/phone.png
// module id = NOPw
// module chunks = 1